import { Box, Card, CardContent, Typography, Grid, Button, Divider, TextField, Stack } from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import GlobalSelectFieldWithoutFormikNew from '../../../../components/mui/GlobalSelectFieldWithoutFormikNew';
import { useEffect, useState } from 'react';
import GlobalViewAttachment from '../../../../components/Fileupload/GlobalViewAttachment';
import { Field, Form, FormikProvider, useFormik } from 'formik';
import * as Yup from 'yup';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import GlobalSelectField from '../../../../components/mui/GlobalSelectField';
import { rejectionReasons } from '../../../../utils/constants/rejectionReasonJson';
import { useDispatch } from 'react-redux';
import useHandleApiResponse from '../../../../Hooks/useHandleApiResponse';
import { postChangeStatus, postNonEnrolledScheduleDateFinance } from '../../../../redux/features/refundSlice';
import { useSelector } from 'react-redux';
import GlobalAllTypeFileView from '../../../../components/Fileupload/GlobalAllTypeFileView';

const STATUS_JSON = [
  { id: 1, name: 'Approve' },
  { id: 2, name: 'Reject' },
  { id: 3, name: 'Hold' },
];

/* Reusable label-value row */
function Info({ label, value = '-' }) {
  return (
    <Box display="flex" mb={1} justifyContent={'space-between'}>
      <Typography fontWeight={500} minWidth={160} color={'gray'}>
        {label}:
      </Typography>
      <Typography>{value}</Typography>
    </Box>
  );
}

const studentInformation = [
  { label: 'Lead Name', value: 'student_name' },
  { label: 'Course', value: 'course_name' },
  { label: 'Project', value: 'project_name' },
  // { label: 'Choosed Payment', value: '' },
  { label: 'Reason', value: 'refund_reason' },

  { label: 'OGA Name', value: 'ogaName' },
  // { label: 'Sales Amount', value: '' },
  // { label: 'Payments', value: '' },
  { label: 'Refund Amount', value: 'holdamount_refund_amount' },
];

const bankAccountDetails = [
  // { label: 'Account Type', value: '' },
  { label: 'Account Holder Name', value: 'refund_ac_holder' },
  { label: 'Account Number', value: 'refund_ac_no' },
  { label: 'IFSC Code', value: 'refund_ifsc' },
];
export default function DetailsAction({ action, data, setOpen, dispatchParams, submitDispatch }) {
  const { submitionLoading } = useSelector((state) => state.refund);

  const dispatch = useDispatch();
  const handleResponseApi = useHandleApiResponse();

  const initialValues = {
    status: '',
    remarks: '',
    scheduled_payment_date: '',
    accountant_rejected_reason_id: '',
  };

  const schema = Yup.object({
    status: Yup.string().required('Status is required'),
    remarks: Yup.string().required('Remarks is required'),

    // remarks: Yup.string().when('status', {
    //   is: (val) => val === '2',
    //   then: (schema) => schema.required('Remarks are required'),
    //   otherwise: (schema) => schema.notRequired(),
    // }),
    scheduled_payment_date: Yup.date().when('status', {
      is: (val) => val === '1',
      then: (schema) => schema.required('Scheduled Payment Date is required'),
      otherwise: (schema) => schema.notRequired(),
    }),
    accountant_rejected_reason_id: Yup.string().when('status', {
      is: (val) => val === '2',
      then: (schema) => schema.required('Rejection Reason is required'),
      otherwise: (schema) => schema.notRequired(),
    }),
  });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues,
    validationSchema: schema,
    onSubmit: async (values) => {
      const REFUND_ID = data?.holdamount_refund_id;

      if (values.status === 1) {
        //approve
        await dispatch(
          postNonEnrolledScheduleDateFinance({
            holdamount_refund_id: REFUND_ID,
            schedule_date: values.scheduled_payment_date,
          }),
        )
          .unwrap()
          .then((res) => {
            dispatch(
              postChangeStatus({
                ...values,
                holdamount_refund_id: REFUND_ID,
                accountant_rejected_reason_id: values.accountant_rejected_reason_id || null,
              }),
            ).then((res) =>
              handleResponseApi(res, {
                onSuccess: () => {
                  setOpen(false);
                },
              }),
            );
          });
      } else {
        //all other
        await dispatch(
          postChangeStatus({
            ...values,
            holdamount_refund_id: REFUND_ID,
            accountant_rejected_reason_id: values.accountant_rejected_reason_id || null,
          }),
        ).then((res) =>
          handleResponseApi(res, {
            onSuccess: () => {
              setOpen(false);
            },
          }),
        );
      }
      dispatch(submitDispatch(dispatchParams));
    },
  });

  useEffect(() => {
    formik.resetForm();
  }, [data]);
  return (
    <Card sx={{ borderRadius: 3, p: 1, minWidth: 800 }} variant="outlined">
      <CardContent>
        <Stack gap={2}>
          <Box>
            <Typography variant="h6" fontWeight={600} mb={3}>
              Student Information
            </Typography>
            {studentInformation.map((item, index) => (
              <Info key={index} label={item.label} value={data?.[item.value]} />
            ))}
          </Box>
          <Divider />
          <Box>
            <Typography variant="subtitle1" fontWeight={600} mb={3}>
              Bank Account Details
            </Typography>
            {bankAccountDetails.map((item, index) => (
              <Info key={index} label={item.label} value={data?.[item.value]} />
            ))}
          </Box>
          <Divider />
          {/* Attachments */}
          <Typography variant="subtitle1" fontWeight={600}>
            Attachments
          </Typography>
          {/* <GlobalViewAttachment attachmentFileName={data?.attachmentUrl} previewButtonName={'View'} /> */}
          <GlobalAllTypeFileView attachmentFiles={[data?.attachmentUrl]} previewButtonName={'View'} />
          {action && (
            <FormikProvider value={formik}>
              <Form
                onSubmit={formik.handleSubmit}
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '10px',
                }}
              >
                <GlobalSelectField
                  options={{
                    formik: formik,
                    label: 'Status',
                    name: 'status',
                    data: STATUS_JSON,
                    keys: {
                      id: 'id',
                      value: 'name',
                    },
                    sx: {
                      width: '100%',
                    },
                  }}
                />
                {formik.values.status === 1 && (
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      label="Scheduled Payment Date"
                      format="DD-MM-YYYY"
                      value={formik.values.scheduled_payment_date ? dayjs(formik.values.scheduled_payment_date) : null}
                      onChange={(value) => formik.setFieldValue('scheduled_payment_date', value?.format('YYYY-MM-DD'))}
                      slotProps={{
                        textField: {
                          fullWidth: true,
                          error: formik.touched.scheduled_payment_date && Boolean(formik.errors.scheduled_payment_date),
                          helperText: formik.touched.scheduled_payment_date && formik.errors.scheduled_payment_date,
                        },
                      }}
                    />
                  </LocalizationProvider>
                )}
                {formik.values.status === 2 && (
                  <GlobalSelectField
                    options={{
                      formik: formik,
                      label: 'Rejection Reasons',
                      name: 'accountant_rejected_reason_id',
                      data: rejectionReasons,
                      keys: {
                        id: 'id',
                        value: 'name',
                      },
                      sx: {
                        width: '100%',
                      },
                    }}
                  />
                )}
                <Field
                  as={TextField}
                  name="remarks"
                  label="Remark"
                  multiline
                  rows={4}
                  fullWidth
                  error={formik.touched.remarks && Boolean(formik.errors.remarks)}
                  helperText={formik.touched.remarks && formik.errors.remarks}
                />

                <Button
                  variant="contained"
                  sx={{ color: 'white', mt: 2 }}
                  startIcon={<CheckCircleIcon />}
                  type="submit"
                  disabled={data?.holdamount_refund_fianance_status == 1 || submitionLoading}
                >
                  {submitionLoading ? 'submitting...' : 'submit'}
                </Button>
              </Form>
            </FormikProvider>
          )}
        </Stack>
      </CardContent>
    </Card>
  );
}
